var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui__vue_hotspot_buttons_box"},[_c('div',{staticClass:"ui__vue_hotspot_buttons",class:_vm.isEditable ? 'active' : ''})])
}
var staticRenderFns = []

export { render, staticRenderFns }